import React from "react"
import { Card } from "antd"
import { LayoutCardLoader, LayoutCardEmpty } from "components"
// TODO needs some organising
import { IRisk, IQuote } from "platform-client/types/quote"
import { IQuoteProduct } from "../../view"
import TravelPackageList from "components/TravelPackageList"
import MotorPackageList from "components/MotorPackageList"
import useOpus from "contexts/opus/hooks/use-opus"
import { useQuery } from "react-query"
import { IRoadsidePackage } from "models/common/package"

const CARD_TITLE = "Sections of cover"

export const QuoteCover: React.FC<IQuoteCover> = (props) => {
  const { policyClient } = useOpus()

  const { data: mtaQuotePolicyBundle } = useQuery(
    ["quote-mta-original-policy", props.mtaPolicyId],
    () => policyClient.getPolicyBundle(props.mtaPolicyId as string),
    {
      enabled: props.quote.quoteType === "MTA" && !!props.mtaPolicyId
    }
  )

  const policyTieredRoadside = mtaQuotePolicyBundle?.risk.addon
    .tieredRoadsideAssistance as IRoadsidePackage

  const addOnsWithMtaPolicyRoadside =
    props.quote.quoteType === "MTA" && !!policyTieredRoadside
      ? {
          ...(props.risk?.core.addon ?? {}),
          tieredRoadsideAssistance: policyTieredRoadside
        }
      : props.risk?.core.addon

  if (props.product?.isGettingQuoteProduct || false) {
    return <LayoutCardLoader title={CARD_TITLE} />
  }

  if (
    props.risk?.core.addon &&
    props.quote.lineOfBusiness === "travel" &&
    props.product?.product !== undefined
  ) {
    return (
      <TravelPackageList
        packages={addOnsWithMtaPolicyRoadside}
        product={props.product.product}
        excess={props.risk?.core.excesses.totalExcess}
      />
    )
  } else if (
    props.product?.productItems_v2 &&
    props.product?.productItems_v2.length > 0 &&
    props.quote.quoteState !== "Open"
  ) {
    return (
      <Card title={CARD_TITLE}>
        <MotorPackageList
          cover={props.product?.productItems_v2}
          addOns={addOnsWithMtaPolicyRoadside}
          additionalProducts={[]}
        />
      </Card>
    )
  } else {
    const quoteOpenText =
      props.quote.quoteState !== "Open"
        ? undefined
        : "Summary not available for open quotes."
    return <LayoutCardEmpty emptyText={quoteOpenText} title={CARD_TITLE} />
  }
}

export interface IQuoteCover {
  quote: IQuote
  product?: IQuoteProduct
  risk?: IRisk
  mtaPolicyId?: string
}
